import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const backgroundColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
];
export const LeaderboardOverlay = defineOverlay({
    defaults: {
        backgroundColor: Color.DEFAULT_RED,
        maxDonors: 5,
    },
    details: {
        category: "overlays",
        description: "Utilize our dynamic Leaderboard overlay to enhance your Tiltify fundraising campaign. Let your viewers easily see who the top donors are for your St. Jude PLAY LIVE campaign",
        features: [
            "<b>Update: Easily set up leaderboard to show all, daily, weekly, monthly, yearly or year to date.</b>",
            "Easily display your donors on stream",
            "Highlights top three donors",
            "Use your dashboard to remove and show donors",
            "Refreshes automatically",
            "Choose the number of donors you want to display",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: true,
            isVisible: true,
        },
        icon: "overlays/leaderboard.png",
        name: "Leaderboard Overlay",
        path: "/overlays/leaderboard",
        shortDescription: "Let your viewers easily see who the top donors are for your campaign.",
        shortName: "Leaderboard",
        slug: "leaderboard",
    },
    schema: BaseOverlayConfig.extend({
        backgroundColor: z
            .enum(backgroundColors)
            .default(() => LeaderboardOverlay._config.defaults.backgroundColor)
            .optional(),
        maxDonors: z
            .number()
            .int()
            .min(1)
            .default(() => LeaderboardOverlay._config.defaults.maxDonors)
            .optional(),
    }),
});
//# sourceMappingURL=leaderboard.js.map